var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audit-list',{attrs:{"audits":_vm.audits,"title":"My Audits / Verifications","subtitle":" ","busy":_vm.isBusy}})}
var staticRenderFns = []

export { render, staticRenderFns }